import type {FC} from 'react';
import clsx from 'clsx';

import {ImageBlock} from '@/modules/foundation/components/image/ImageBlock';
import {Link} from '@/modules/foundation/components/link';
import {createPhoneLink, formatPhoneNumber} from '@/modules/foundation/shared/format';

import type {Person} from '../../shared/types';

export interface PersonCardProps {
	person: Person;
}

export const PersonCard: FC<PersonCardProps> = ({person}) => {
	const {name, image, phone, email, role} = person;

	return (
		<div className={clsx('relative', 'shadow-md')}>
			<ImageBlock
				alt={image.altText ?? ''}
				height={image.image.height}
				width={image.image.width}
				src={image.image.src}
			/>

			<div className={clsx('flex', 'flex-col', 'px-4', ' py-5', 'gap-3', 'text-sm')}>
				<div className={clsx('flex', 'flex-col')}>
					<span
						className={clsx(
							'font-semibold',
							'text-dypgronn-industri',
							'uppercase',
							'text-base',
						)}
					>
						{name}
					</span>

					{role && <span className="text-xs">{role}</span>}
				</div>

				{phone && (
					<Link
						href={createPhoneLink(phone)}
						className={clsx('no-underline', 'hover:underline')}
					>
						{formatPhoneNumber(phone)}
					</Link>
				)}

				{email && (
					<Link
						href={`mailto:${email}`}
						className={clsx(
							'break-words',
							'text-oransje-industri',
							'hover:no-underline',
						)}
					>
						{email}
					</Link>
				)}
			</div>
		</div>
	);
};
